import React from 'react';
import { Routes, Route } from 'react-router';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import TimesAnomalyContextProvider from '../../state/timesAnomaly/TimesAnomalyContextProvider';
import SelectOrgUnitContextProvider from '@usas/ui-web/state/selectOrgUnit/SelectOrgUnitContextProvider';
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';
import LscContextProvider from '@usas/ui-web/state/lsc/LscContextProvider';
import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';

import TimesAnomalyContextView from './TimesAnomalyContextView';
import OrgUnitSelection from './orgUnitSelection/OrgUnitSelection';
import TimesAnomalySearch from './timesAnomalySearch/TimesAnomalySearch';

const ContextRoutes = ({ navRoutes }) => (
  <TimesAnomalyContextProvider>
    <TimesAnomalyContextView>
      <LscContextProvider>
        <Routes>
          <Route path={navRoutes['TIMES_ANOMALY_SEARCH']?.path}
            element={
              <SecuredRouteElement
                navRoute={navRoutes['TIMES_ANOMALY_SEARCH']}
                editElement={<TimesAnomalySearch />} />
            }
          />
        </Routes>
      </LscContextProvider>
    </TimesAnomalyContextView>
  </TimesAnomalyContextProvider>
);

const TimesAnomalyRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <Routes>
      <Route path={navRoutes['TIMES_ANOMALY_SELECTION']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['TIMES_ANOMALY_SELECTION']}
            editElement={<OrgUnitSelection />} />
        }
      />
      <Route path={'/*'} element={<ContextRoutes navRoutes={navRoutes} />} />
      <Route path={'/'} element={<Navigate to={navRoutes['TIMES_ANOMALY_SELECTION']?.route} replace />} />
    </Routes>
  )
};

const TimesAnomaly = () => (
  <SelectOrgUnitContextProvider>
    <PersonOrgRoleContextProvider>
      <TimesAnomalyRoutes />
    </PersonOrgRoleContextProvider>
  </SelectOrgUnitContextProvider>
);

export default TimesAnomaly;